import { toast } from "react-toastify";
import { postLoginInstance, preLoginInstance } from "../../utils";
import { API_LIMIT, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllListData } from "../MasterCategory/MasterCategoryAction";
import { getLabelByValue, filterVerifiedItems } from "../../utils/ReusableFunctions";



export const getAllCampaignApi = (ctx = {}, onHide = null) => {
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    let verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : '';
    ctx?.setState?.({ isLoading: true });
    return postLoginInstance.get(
      `campaign?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE
      }${searchValue && `&searchValue=${searchValue}`}`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.campaignName,
            value: item.uuid,
            count: item.count
          }));
          ctx.setState({
            campaignOption: option
          })
        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};
export const getCampaignByFilterApi = async (filter) => {

  const params = { pageSize: MAX_LIMIT, pageNumber: 1 };
  const amcUuidArr = filter?.amc ? filter?.amc : null
  const createrUuidArr = filter?.creater ? filter?.creater : null

  const amcArr = amcUuidArr?.map((item) => {
    return getLabelByValue(item, filter?.amcOptions) || null;
  })

  const createrArr = createrUuidArr?.map((item) => {
    return getLabelByValue(item, filter?.createrOptions) || null;
  })

  if (amcArr?.length > 0) {
    params.amc = amcArr?.join(",")
  }
  if (createrArr?.length > 0) {
    params.creator = createrArr?.join(",")
  }

  try {
    const response = await postLoginInstance.get(`campaign`, {
      params
    });
    if (response.status < 250 && response.status > 199) {
      return filterVerifiedItems(response.data.data.list);
    }
    return [];
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return [];
  }
}
export const getAllCampaignAdsApi = (ctx = {}, onHide = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : '';
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    return postLoginInstance.get(
      `campaignAd?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size}&pageNumber=${page
      }${searchValue && `&searchValue=${searchValue}`}`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.campaignName,
            value: item.uuid
          }));
          ctx?.setState({
            campaignOption: option
          })
        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      }).catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const addCampaignApi = async (data, ctx) => {
  try {
    const response = await postLoginInstance.post('campaign', data);
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Save.")
      ctx.props.getAllCampaignApi(ctx);
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}
export const addCampaignAdsApi = (data, ctx, onHide, ctx2) => {
  return postLoginInstance.post("campaignAd", data).then((res) => {
    toast.success("Successfully Save.")
    ctx2.props.history('/campaign-ads')
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
    .finally(() => {
      ctx2?.setState({ resLoading: false })
    })
};

export const updateCampaignApi = async (url, data, ctx = null) => {
  try {
    const response = await postLoginInstance.put(url, data);
    console.log(response)
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Updated.")
      ctx.props.getAllCampaignApi(ctx);
    }
    return response;
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}
export const updateCampaignAdsApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.put(`campaignAd/${id}`, data).then((res) => {
    ctx2.props.history('/campaign-ads')
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      toast.error(error.message || 'Something went wrong.');
    })
    .finally(() => {
      ctx2?.setState({ resLoading: false })
    })
}

export const deleteCampaignApi = async (id, ctx) => {
  try {
    const response = await postLoginInstance.delete(`campaign/${id}`);
    if (response.status < 250 && response.status > 199) {
      toast.success("Successfully Deleted.")
      ctx.props.getAllCampaignApi(ctx);
    }
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  }
}
export const deleteCampaignAdsApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`campaignAd/${id}`).then((res) => {
    ctx.props.getAllCampaignAdsApi(null, onHide);
    toast.success("Successfully Deleted.")
  }
  ).catch((error) => {
    console.log(error)
    toast.error(error.message || 'Something went wrong.');
  })
};


// ========================= EVENT ADS API START =========================
export const getAllEventAdsApi = (ctx = {}, onHide = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : '';
    const pageSize = params.get("pageSize") || API_LIMIT;
    const page = params.get("page") || START_PAGE;
    return postLoginInstance.get(
      `eventAd?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize}&pageNumber=${page
      }${searchValue && `&searchValue=${searchValue}`}`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.eventAdName,
            value: item.uuid
          }));
          ctx.setState({
            campaignOption: option
          })
        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};
export const addEventAdsApi = (data, ctx, onHide, ctx2) => {

  return postLoginInstance.post("eventAd", data).then((res) => {

    toast.success("Successfully Save.")
    ctx2.props.history('/event-ads')
    ctx2?.setState({ resLoading: false })
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};

export const updateEventAdsApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.put(`eventAd/${id}`, data).then((res) => {
    ctx2.props.history('/event-ads')
    toast.success("Successfully Updated.")
    ctx2?.setState({ resLoading: false })
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error.message || 'Something went wrong.');
    })
};
export const deleteEventAdsApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`eventAd/${id}`).then((res) => {
    ctx.props.getAllEventAdsApi(null, onHide);
    toast.success("Successfully Deleted.")
  }).catch((error) => {
    toast.error(error.message || 'Something went wrong.');
  })
};
// =====================ASSIGN PLAN API START HERE
export const getAssignPlanApi = (ctx = {}, onHide = null) => {
  return function (dispatch, getState) {
    return postLoginInstance.get(
      `user-billing-plan?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE
      }`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {

        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      })
  };
};
export const addAssignPlanApi = (data, ctx, onHide) => {

  return postLoginInstance.post("user-billing-plan", data).then((res) => {
    ctx.props.getAssignPlanApi(null, onHide);
    toast.success("Successfully Save.")
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};
export const updateAssignPlanApi = (data, ctx, onHide, id) => {

  return postLoginInstance.put(`user-billing-plan/${id}`, data).then((res) => {
    ctx.props.getAssignPlanApi(null, onHide);
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      toast.error(error.message || 'Something went wrong.');
    })
};

export const deleteAssignPlanApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`user-billing-plan/${id}`).then((res) => {
    ctx.props.getAssignPlanApi(null, onHide);
    toast.success("Successfully Deleted.")
  }).catch((error) => {
    toast.error(error.message || 'Something went wrong.');
  })
};
// ============================= USER GROPUP API START -==============
export const getAllUsergroupApi = (ctx = {}, onHide = null) => {
  const { verifyUrl = false } = ctx?.state || {};
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {

    return postLoginInstance.get(
      `notification-group?${verifyUrl ? verifyUrl + '&' : ''}`

    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.campaignName,
            value: item.uuid
          }));
          ctx.setState({
            campaignOption: option
          })
        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const addUserGroupApi = (data, ctx, onHide, ctx2) => {

  return postLoginInstance.post("notification-group", data).then((res) => {
    ctx.props.getAllUsergroupApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Save.");
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error.message || 'Something went wrong.');
    })
};
export const updateUserGroupApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.patch(`notification-group/${id}`, data).then((res) => {
    ctx.props.getAllUsergroupApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};

export const deleteUserGroupApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`notification-group/${id}`).then((res) => {
    ctx.props.getAllUsergroupApi(null, onHide);
    toast.success("Successfully Deleted.")
  }).catch((error) => {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
// ============================= TEMPLATE API START -==============
export const getAllTemplateApi = (ctx = {}, onHide = null) => {
  const { verifyUrl } = ctx.state;
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {

    return postLoginInstance.get(
      `notification-template?${verifyUrl ? verifyUrl + '&' : ''}`

    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.title + " - " + item.type.toUpperCase(),
            value: item.uuid
          }));
          ctx.setState({
            templateOptions: option
          })
        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const addTemmplateApi = (data, ctx, onHide) => {

  return postLoginInstance.post("notification-template", data).then((res) => {
    ctx.props.getAllTemplateApi(null, onHide);
    toast.success("Successfully Save.");
  })
    .catch((error) => {
      toast.error(error.message || 'Something went wrong.');
    })
};
export const updateTemplateApi = (data, ctx, onHide, id) => {

  return postLoginInstance.patch(`notification-template/${id}`, data).then((res) => {
    ctx.props.getAllTemplateApi(null, onHide);
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};

export const deleteTemplateApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`notification-template/${id}`).then((res) => {
    ctx.props.getAllTemplateApi(null, onHide);
    toast.success("Successfully Deleted.")
  }).catch((error) => {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
// =========== NOTIFICATION SETUP APIS START
export const getAllNotificationSetupApi = (ctx = {}, onHide = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : '';
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const pageSize = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    return postLoginInstance.get(
      // `notification-setup`
      `notification-setup?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize}&pageNumber=${page}`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.campaignName,
            value: item.uuid
          }));
          ctx.setState({
            campaignOption: option
          })

        } else {
          dispatch(getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }

        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const addNotificationSetupApi = (data, ctx, onHide) => {

  return postLoginInstance.post("notification-setup", data).then((res) => {
    ctx.props.getAllNotificationSetupApi(ctx, onHide);
    toast.success("Successfully Save.");
    ctx.setState({
      showEdit: false
    })
  })
    .catch((error) => {
      toast.error(error.message || 'Something went wrong.');
    })
};
export const updateNotificationSetupApi = (data, ctx, onHide, id) => {

  return postLoginInstance.put(`notification-setup/${id}`, data).then((res) => {
    ctx.props.getAllNotificationSetupApi(ctx, onHide);
    toast.success("Successfully Updated.")
    ctx.setState({
      showEdit: false
    })
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })

};




export const getAllTargetedListApi = (ctx = {}, onHide = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    return postLoginInstance.get(
      `targetedContent?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE
      }`
    )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.targetedContentName,
            value: item.uuid
          }));
          ctx.setState({
            targetedContentOption: option
          })
        } else {
          dispatch(
            getAllListData(res.data.data, ctx?.state.currentPage || START_PAGE));
        }
        if (!ctx) {
          onHide();
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};

export const addTargetedApi = (data, ctx, onHide, ctx2) => {

  return postLoginInstance.post("targetedContent", data).then((res) => {
    ctx.props.getAllTargetedListApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Save.")
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};
export const updateTargetedApi = (data, ctx, onHide, id, ctx2) => {

  return postLoginInstance.put(`targetedContent/${id}`, data).then((res) => {
    ctx.props.getAllTargetedListApi(null, onHide);
    ctx2?.setState({ resLoading: false })
    toast.success("Successfully Updated.")
  })
    .catch((error) => {
      ctx2?.setState({ resLoading: false })
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};

export const deleteTargetedApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`targetedContent/${id}`).then((res) => {
    ctx.props.getAllTargetedListApi(null, onHide);
    toast.success("Successfully Deleted.")
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
};


export const getCollectionDetailsApi = (ctx) => {
  return postLoginInstance.get(`/${ctx.state.url}/${ctx.state.id}`)
    .then((res) => {

      ctx.setState({
        data: res.data.data
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getAllUsersApi = (ctx) => {
  return postLoginInstance.get(`customer?pageSize=1000000000&pageNumber=1`)
    .then((res) => {

      ctx.setState({
        usersOptions: res.data.data
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getPlanApi = (ctx) => {
  return postLoginInstance.get(`premium-plan`)
    .then((res) => {
      ctx.setState({
        planOptions: {
          ...res.data.data,
          list: filterVerifiedItems(res.data.data?.list),
        }
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getAllShedularApi = (ctx) => {
  return postLoginInstance.get(`notification-sheduler`)
    .then((res) => {

      ctx.setState({
        scheudlerUuidOptions: res.data.data
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getGroupUserApi = (ctx) => {
  return postLoginInstance.get(`notification-group`)
    .then((res) => {

      ctx.setState({
        usersGroupOptions: {
          ...res.data.data,
          list: filterVerifiedItems(res.data.data?.list),
        }
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getAllGroupUsers = (ctx) => {
  return postLoginInstance.get(`notification-group/${ctx.props?.editData?.uuid}`)
    .then((res) => {

      ctx.setState({
        userUuids: res.data.data?.members?.map(item => item?.user?.uuid)
      })
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}
export const getFilterListTargeted = (ctx) => {
  return postLoginInstance.get(`/targetedContentFilters`)
    .then((res) => {

      let list = filterVerifiedItems(res.data.data?.list)?.filter(item => item.isTargetedContent === false)
      ctx.setState({
        targetedList: list
      })

    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || 'Something went wrong.');
    })
}